import { useQuery } from '@tanstack/react-query';
import qs from 'qs';
import type { AgentApiCandidateEndpointsCopyTargetCandidate } from '@/types/serializers';

export type CopyTargetCandidatesQuery = {
  keyword?: string;
  assignee_id?: number;
  candidate_profile_id?: number;
};

type Response = {
  records: AgentApiCandidateEndpointsCopyTargetCandidate[];
};

export default function useCopyTargetCandidates(query: CopyTargetCandidatesQuery, enabled = true) {
  return useQuery({
    queryKey: ['/agent/api/candidate_endpoints/copy_target_candidates', query],
    enabled,
    retry: false,
    refetchOnWindowFocus: false,
    queryFn: async () => {
      const q = qs.stringify(query, { arrayFormat: 'brackets', skipNulls: true });
      const response = await fetch(
        `/agent/api/candidate_endpoints/copy_target_candidates.json?${q}`
      );
      if (!response.ok) {
        throw new Error('Failed to fetch copy target candidates');
      }
      const data: Response = await response.json();
      return data;
    },
  });
}
